import $ from 'jquery'

if ($('#search_map,.shortcode_gmap').length) {
  window.themeLoadPlugin([__PUBLIC_PATH__ + 'leaflet/leaflet.js'], [__PUBLIC_PATH__ + 'leaflet/leaflet.css'], function () {
    window.themeLoadPlugin([__PUBLIC_PATH__ + 'leaflet/leaflet.markercluster.js'], [__PUBLIC_PATH__ + 'leaflet/MarkerCluster.css', __PUBLIC_PATH__+'leaflet/MarkerCluster.Default.css'], function () {
      window.themeLoadPlugin([__PUBLIC_PATH__ + 'js/openstreetmaps.js'], [], function () {
        $('.shortcode_gmap').each(function (k, el) {
          shortcode_openmap($(this).attr('id'));
        });
      });
    });
  });
}



// WEBPACK FOOTER //
// ./src/themes/pac/js/openstreetmap.js